import conutryarr from '@/components/common/country.js'
import {
  customLocalStorage,
  customSessionStorage,
  getStorageKey,
  unifiedCookieStorage,
} from './storage'
import { localeMap } from './constant'

export const getCountry = () => {
  const browserLang = (
    navigator.appName == 'Netscape' ? navigator.language : navigator.userLanguage
  ).toLowerCase()
  const country =
    {
      'zh-hk': 'HK', // HKD - 中国香港
      'zh-tw': 'TW', // TWD - 中国台湾
      ja: 'JP', // JPY - 日本
      ko: 'KR', // KRW - 韩国
      'en-sg': 'SG', // SGD - 英语(新加坡)
      'en-gb': 'GB', // GBP - 英语(英国)
      'en-gb-oxendict': 'GB', // GBP - 英语(英国)
      'en-au': 'AU', // AUD - 英语(澳大利亚)
      'en-za': 'ZA', // ZAR - 英语(南非)
      'ar-sa': 'SA', // SAR - 阿拉伯语(沙特阿拉伯)
      'ar-iq': 'IQ', // USD - 阿拉伯语(伊拉克)
      'ar-ae': 'US', // USD - 阿拉伯语(阿联酋)
      th: 'TH', // THB - 泰语
      de: 'DE', // EUR - 德语
      'de-de': 'DE', // EUR - 德语(德国)
      'de-ch': 'CH', // CHF - 德语(瑞士)
      pt: 'PT', // EUR - 葡萄牙语
      'pt-br': 'PT', // EUR - 葡萄牙语(巴西)
      'pt-pt': 'PT', // EUR - 葡萄牙语(葡萄牙)
      ru: 'RU', // RUB - 俄语
      es: 'ES', // EUR - 西班牙语
      'fr-ch': 'CH', // CHF - 法语(瑞士)
      vi: 'VI', // VND - 越南语
    }[browserLang] || 'US'
  const browserCurrency = conutryarr.find((v) => v.content === country)
  const supportCurrency = (process.env.VUE_APP_SUPPORT_CURRENCY || '').split(',')
  // 币种不支持
  if (!supportCurrency.includes(browserCurrency.money)) {
    const defaultCountry = 'US'
    return conutryarr.find((v) => v.content === defaultCountry)
  } else {
    return browserCurrency
  }
}

// 获取浏览器语言
export const getBrowserLang = () => {
  const lang = (
    navigator.appName == 'Netscape' ? navigator.language : navigator.userLanguage
  ).toLowerCase()
  let langKey = ''
  if (lang === 'zh' || lang === 'zh-cn' || lang.startsWith('zh-Hans')) {
    langKey = 'zh-Hans' // 简体中文
  } else if (lang.startsWith('en')) {
    langKey = 'EN' // 英文
  } else if (
    lang.indexOf('zh-tw') > -1 ||
    lang.indexOf('zh-hant') > -1 ||
    lang.indexOf('zh-mo') > -1 ||
    lang.indexOf('zh-hk') > -1
  ) {
    langKey = 'zh-Hant' // 繁中
  } else if (lang.startsWith('de')) {
    langKey = 'DE' // 德语
  } else if (lang.startsWith('fr')) {
    langKey = 'FR' // 法语
  } else if (lang.startsWith('es')) {
    langKey = 'ES' // 西班牙语
  } else if (lang.startsWith('id')) {
    langKey = 'ID' // 印尼语
  } else if (lang.startsWith('th')) {
    langKey = 'TH' // 泰语
  } else if (lang.startsWith('ru')) {
    langKey = 'RU' // 俄语
  } else if (lang.startsWith('vi')) {
    langKey = 'VI' // 越南语
  } else if (lang.startsWith('ko')) {
    langKey = 'KO' // 韩语
  } else if (lang.startsWith('ja')) {
    langKey = 'JA' // 日语
  } else if (lang.startsWith('ar')) {
    langKey = 'AR' // 阿拉伯语
  } else if (lang.startsWith('pt')) {
    langKey = 'PT' // 葡萄牙语
  } else if (lang.startsWith('tr')) {
    langKey = 'TR' // 土耳其语
  } else if (lang.startsWith('it')) {
    langKey = 'IT' // 意大利语
  } else if (lang.startsWith('nl')) {
    langKey = 'NL' // 兰语语
  } else if (lang.startsWith('pl')) {
    langKey = 'PL' // 波兰语
  } else if (lang.startsWith('ru')) {
    langKey = 'RU' // 俄罗斯语言
  } else {
    langKey = 'EN'
  }

  if (localeMap[langKey]) {
    return langKey
  }

  return 'EN'
}

export const getLang = () => {
  const lang =
    customLocalStorage.getItem('vipMallLangCode') || customSessionStorage.getItem('vipMallLangCode')
  return lang && localeMap[lang] ? lang : getBrowserLang()
}

// 节流函数
export const throttle = (fn, delay = 300) => {
  let timer = null
  return function (...args) {
    if (timer) return
    timer = setTimeout(() => {
      fn.apply(this, args)
      timer = null
    }, delay)
  }
}

// 防抖
export const debounce = (fn, delay = 300) => {
  let timer = null
  return function (...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

// 校验邮箱
export const validateEmail = (val) => {
  if (!val) {
    return false
  }
  if (
    !/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|(?:\[(?:(?:25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})\.){3}(?:25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})\]))$/.test(
      val
    )
  ) {
    return false
  }
  return true
}

// 获取支付条款链接
export const getPaymentTermsUrl = (locale) => {
  const localeMap = JSON.parse(process.env.VUE_APP_PAYMENT_TERMS_LANG_PATH)
  return `${process.env.VUE_APP_PAYMENT_TERMS_URL.replace('{LANG_PATH}', localeMap[locale] || localeMap['DEFAULT'])}`
}
export const getTermsOfServiceUrl = (locale) => {
  const localeMap = JSON.parse(process.env.VUE_APP_TERMS_OF_SERVICE_LANG_PATH)
  return `${process.env.VUE_APP_TERMS_OF_SERVICE_URL.replace('{LANG_PATH}', localeMap[locale] || localeMap['DEFAULT'])}`
}
export const getPrivacyPolicyUrl = (locale) => {
  const localeMap = JSON.parse(process.env.VUE_APP_PRIVACY_POLICY_LANG_PATH)
  return `${process.env.VUE_APP_PRIVACY_POLICY_URL.replace('{LANG_PATH}', localeMap[locale] || localeMap['DEFAULT'])}`
}

export const os = navigator.userAgent.toLowerCase().includes('android') ? 'android' : 'ios'

export const buildScheme = (scheme, universal_link) => {
  //在facebook或isMessenger打开
  const isMessenger = /FBAV\//i.test(navigator.userAgent)
  //dingding
  //const isdingding = /DingTalk/i.test(navigator.userAgent);
  //Snapchat、Instagram、line、
  const isSnapchat = /Snapchat/i.test(navigator.userAgent)
  const isKakao = /KAKAOTALK/i.test(navigator.userAgent)
  //const isLINE = /Line/i.test(navigator.userAgent);

  let appenv = false

  if (isMessenger || isSnapchat || isKakao) {
    appenv = true
  } else {
    appenv = false
  }
  if (os === 'android') {
    return scheme
  } else {
    return appenv ? universal_link : scheme
  }
}

export const getAppleDeviceType = () => {
  const ua = navigator.userAgent || ''
  const platform = navigator.platform || ''
  const maxTouchPoints = navigator.maxTouchPoints || 0

  const isiPhone = /iPhone/i.test(ua)
  const isIPad = /iPad/i.test(ua)

  // iPadOS 13+ 会使用 MacIntel，但可以通过触摸点数识别
  const isiPadNew = platform === 'MacIntel' && maxTouchPoints > 1

  const isMac = /Macintosh/i.test(ua) && !isiPadNew

  if (isiPhone) return 'iPhone'
  if (isIPad || isiPadNew) return 'iPad'
  if (isMac) return 'Mac'

  return 'Other'
}

export const isHideAirwallex = () => {
  return process.env.VUE_APP_HIDE_AIRWALLEX === 'true'
}
export const isHidePrimer = () => {
  return process.env.VUE_APP_HIDE_PRIMER === 'true'
}

// 根据时间返回 天 时 分 秒
// 如果时间小于 1 天，则返回 时 分 秒
// 入参单位：秒，返回格式：两位数的时分秒
const formatTime = (time) => {
  time = isNaN(time) ? 0 : Math.abs(time)
  const days = Math.floor(time / (60 * 60 * 24))
  const hours = Math.floor((time % (60 * 60 * 24)) / (60 * 60))
  const minutes = Math.floor((time % (60 * 60)) / 60)
  const seconds = Math.floor(time % 60)

  // 兼容性更好的格式化为两位数方法
  const formatNumber = (num) => {
    const str = num.toString()
    return str.length < 2 ? '0' + str : str
  }

  if (days > 0) {
    return `${days}D ${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
  } else {
    return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
  }
}

export const isIPadOS26 = () => {
  const ua = navigator.userAgent
  const isIPad = /iPad/.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(ua))
  const versionMatch = ua.match(/Version\/(\d+)/) || ua.match(/OS (\d+)[_.]/)

  const iosVersion = versionMatch ? parseInt(versionMatch[1], 10) : 0
  console.log('ipad,iosVersion', isIPad, iosVersion, ua)
  return isIPad && iosVersion >= 26
}

export const formatUTCTimestamp = (timestamp) => {
  const date = new Date(timestamp)
  const Y = date.getUTCFullYear()
  const M = String(date.getUTCMonth() + 1).padStart(2, '0') // 月份从 0 开始
  const D = String(date.getUTCDate()).padStart(2, '0')
  const h = String(date.getUTCHours()).padStart(2, '0')
  const m = String(date.getUTCMinutes()).padStart(2, '0')
  const s = String(date.getUTCSeconds()).padStart(2, '0')
  return `${Y}-${M}-${D} ${h}:${m}:${s}`
}

export default {
  os,
  getBrowserLang,
  throttle,
  debounce,
  validateEmail,
  getPaymentTermsUrl,
  getTermsOfServiceUrl,
  getPrivacyPolicyUrl,
  customLocalStorage,
  customSessionStorage,
  getStorageKey,
  unifiedCookieStorage,
  getLang,
  buildScheme,
  getAppleDeviceType,
  isHideAirwallex,
  isHidePrimer,
  formatTime,
  formatUTCTimestamp,
  isIPadOS26,
}
